import { CircleAlert } from 'lucide-react';
import { cn } from '@/lib/utils';

interface FormErrorMessageProps {
	isShowing?: boolean;
	message?: string;
	className?: string;
}

export const FormErrorMessage = ({
	isShowing = false,
	message = '',
	className,
}: FormErrorMessageProps) => (
	<>
		{isShowing && (
			<div className={cn('flex w-full py-2 pr-2 text-body', className)}>
				<CircleAlert className="w-4 h-4 text-red-500 mr-2" />
				<span className="text-sm">{message}</span>
			</div>
		)}
	</>
);

export default FormErrorMessage;
